/**
 * @fileoverview POST handler for the "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExportCacheKeys } from "./constants";
import type { PostCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExportProps } from "./types";

export const postCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExport = reactQueryMutationAdapter(
  companySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExportCacheKeys,
  (props: PostCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExportProps): Promise<void> => {
    return fetch("/company_settings/most_used_events_and_attributes_by_apps_and_app_groups_export", "POST", props);
  }
);
